import { FC, memo } from 'react';
import { useParams } from 'react-router-dom';

import { AppCardList } from '@/common/components';
import { AppRoutes, BaseQueryParams } from '@/common/interfaces';

import { DnsRecordsApiProviderTag, useGetAllDnsRecordsQuery } from '@/modules/DnsRecords';

interface Props {
  currentPage: number;
  dnsRecordsListItems: (BaseQueryParams<typeof useGetAllDnsRecordsQuery>['data']['items'][0])[];
  dnsRecordsListTotalItems: number;
  dnsRecordsListItemsPerPage: number;
  isLoading: boolean;
  handleChangePage: (page: number) => void;
}

export const DnsRecordsListView: FC<Props> = memo(
  ({
    currentPage,
    dnsRecordsListItems,
    dnsRecordsListTotalItems,
    dnsRecordsListItemsPerPage,
    isLoading,
    handleChangePage
  }) => {
    const domainRegistrarId = useParams()['*'];

    return (
      <AppCardList
        headerTitle={ null }
        pagination={{
          current: currentPage,
          total: dnsRecordsListTotalItems,
          pageSize: dnsRecordsListItemsPerPage,
          disabled: isLoading,
          onChange: (page: number) => handleChangePage(page)
        }}
        selectedKey={ domainRegistrarId }
        rowKey="id"
        titleKey="name"
        grid={{
          gutter: 16,
          xs: 1,
          sm: 1,
          md: 1,
          lg: 2,
          xl: 2,
          xxl: 3
        }}
        navigateTo={ ({ id }) => ({ to: AppRoutes.DnsRecordsById.replace(':dnsRecordId', id) }) }
        content={ ({ apiProvider }) => apiProvider && <DnsRecordsApiProviderTag provider={ apiProvider }/> }
        list={ dnsRecordsListItems }
      />
    );
  }
);
